import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IOfferBoxOffer} from "../../offer/types/IOfferBoxOffer";
import {getAmplitudeOfferSelectItemEventProperties, IAmplitudeOfferListingTileContext} from "./get_amplitude_offer_select_item_event_properties";
import {AmplitudeItemListName, IAmplitudeViewItemOffer} from "./get_amplitude_view_item_event_properties";

export interface ITrackAmplitudeOfferSelectItemParams {
    offer: IOfferBoxOffer | IAmplitudeViewItemOffer;
    index: number;
    itemListId?: string;
    itemListName?: AmplitudeItemListName;
    listingTileContext?: IAmplitudeOfferListingTileContext;
}

export const trackAmplitudeOfferSelectItem = (params: ITrackAmplitudeOfferSelectItemParams) => {
    trackAmplitudeEvent("select_item", getAmplitudeOfferSelectItemEventProperties(params));
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IOfferBoxOffer} from "../../offer/types/IOfferBoxOffer";
import {getAmplitudeOfferSelectItemEventProperties, IAmplitudeOfferListingTileContext} from "./get_amplitude_offer_select_item_event_properties";
import {AmplitudeItemListName, IAmplitudeViewItemOffer} from "./get_amplitude_view_item_event_properties";

export interface ITrackAmplitudeOfferSelectItemParams {
    offer: IOfferBoxOffer | IAmplitudeViewItemOffer;
    index: number;
    itemListId?: string;
    itemListName?: AmplitudeItemListName;
    listingTileContext?: IAmplitudeOfferListingTileContext;
}

export const trackAmplitudeOfferSelectItem = (params: ITrackAmplitudeOfferSelectItemParams) => {
    trackAmplitudeEvent("select_item", getAmplitudeOfferSelectItemEventProperties(params));
};
